import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';

export const getOmniConfigurationState = createSelector(getDragonflyState, (state) => state.omniConfiguration);

export const getNameOmni = createSelector(getOmniConfigurationState, ({ nameOmni }) => nameOmni);

export const getStatusOmni = createSelector(getOmniConfigurationState, ({ isActiveOmni }) => isActiveOmni);

export const getSmsSenderOmni = createSelector(getOmniConfigurationState, ({ smsSenderOmni }) => smsSenderOmni);

export const getViberSenderOmni = createSelector(getOmniConfigurationState, ({ viberSenderOmni }) => viberSenderOmni);

export const getAccountIdOmni = createSelector(getOmniConfigurationState, ({ accountIdOmni }) => accountIdOmni);

export const getApiTokenOmni = createSelector(getOmniConfigurationState, ({ apiTokenOmni }) => apiTokenOmni);

export const getNotificationEmailOmni = createSelector(
  getOmniConfigurationState,
  ({ notificationEmailOmni }) => notificationEmailOmni,
);

export const getLookBackDaysOmni = createSelector(
  getOmniConfigurationState,
  ({ lookBackDaysOmni }) => lookBackDaysOmni,
);

export const getShowUpdateBtn = createSelector(getOmniConfigurationState, ({ showUpdateBtn }) => showUpdateBtn);

export const getDisableNameValue = createSelector(getOmniConfigurationState, ({ disableName }) => disableName);

export const getShowCancelBtn = createSelector(getOmniConfigurationState, ({ showCancelBtn }) => showCancelBtn);

export const getIntegrationConfHelpTextStatus = createSelector(
  getOmniConfigurationState,
  ({ integrationConfHelpTextStatus }) => integrationConfHelpTextStatus,
);

export const getCredentialsConfHelpTextStatus = createSelector(
  getOmniConfigurationState,
  ({ credentialsConfHelpTextStatus }) => credentialsConfHelpTextStatus,
);

export const getNotificationHelpTextStatus = createSelector(
  getOmniConfigurationState,
  ({ notificationHelpTextStatus }) => notificationHelpTextStatus,
);

export const getCampaignReportingHelpTextStatus = createSelector(
  getOmniConfigurationState,
  ({ campaignReportingHelpTextStatus }) => campaignReportingHelpTextStatus,
);

export const getOmniDataIsSubmitted = createSelector(
  getOmniConfigurationState,
  ({ isSubmittedData }) => isSubmittedData,
);

export const getShowNameErrorMsg = createSelector(
  getNameOmni,
  getOmniDataIsSubmitted,
  (name, dataIsSubmitted) => !name && dataIsSubmitted,
);

export const getShowSmsSenderErrorMsg = createSelector(
  getSmsSenderOmni,
  getOmniDataIsSubmitted,
  (smsSender, dataIsSubmitted) => !smsSender && dataIsSubmitted,
);

export const getShowViberSenderErrorMsg = createSelector(
  getViberSenderOmni,
  getOmniDataIsSubmitted,
  (viberSender, dataIsSubmitted) => !viberSender && dataIsSubmitted,
);

export const getShowAccountIdErrorMsg = createSelector(
  getAccountIdOmni,
  getOmniDataIsSubmitted,
  (accountId, dataIsSubmitted) => !accountId && dataIsSubmitted,
);

export const getShowApiTokenErrorMsg = createSelector(
  getApiTokenOmni,
  getOmniDataIsSubmitted,
  getShowUpdateBtn,
  (apiToken, dataIsSubmitted, isEditMode) => !apiToken && dataIsSubmitted && !isEditMode,
);

export const getNotificationEmailErrorMsg = createSelector(
  getNotificationEmailOmni,
  getOmniDataIsSubmitted,
  (email, dataIsSubmitted) => {
    if (!dataIsSubmitted) return false;
    if (!email) return true;
    return !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@[A-Za-z0-9.-]{2,})+\.[A-Za-z]{2,}/.test(email);
  },
);

export const getLookBackDaysErrorMsg = createSelector(
  getLookBackDaysOmni,
  getOmniDataIsSubmitted,
  (lookBackDays, dataIsSubmitted) =>
    (lookBackDays === null || lookBackDays < 0 || lookBackDays > 30) && dataIsSubmitted,
);

export const getOmniDataAreValid = createSelector(
  getNameOmni,
  getSmsSenderOmni,
  getViberSenderOmni,
  getAccountIdOmni,
  getApiTokenOmni,
  getNotificationEmailErrorMsg,
  getLookBackDaysErrorMsg,
  getShowUpdateBtn,
  (name, smsSender, viberSender, accountId, apiToken, emailError, lookBackDaysError, isEditMode) =>
    name && smsSender && viberSender && accountId && (apiToken || isEditMode) && !emailError && !lookBackDaysError,
);
